module.exports = __webpack_public_path__ + "img/waiting.fdbe0d59.svg";